import { useCallback } from 'react';

interface QuestionsCountTextFieldHookInput<TQuestion extends object> {
  questionsCount: number;

  getQuestionToAppend: (index: number) => TQuestion;
  onRemove: (index: number[]) => void;
  onAdd: (fields: TQuestion[]) => void;

  onChangeQuestionsCountTex: (newValue: string) => void;
}

interface QuestionsCountTextFieldHookOutput {
  onChangeQuestionsCount: React.ChangeEventHandler<HTMLTextAreaElement>;
}

export default function useQuestionsCountTextField<TQuestion extends object>(
  input: QuestionsCountTextFieldHookInput<TQuestion>
): QuestionsCountTextFieldHookOutput {
  const { onRemove, onAdd, getQuestionToAppend, questionsCount, onChangeQuestionsCountTex } = input;

  const handleChangeQuestionsCount = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChangeQuestionsCountTex(event.target.value);
      const value = parseInt(event.target.value, 10) || 0;
      if (!value) return;

      if (value > questionsCount) {
        const questionsToAdd: TQuestion[] = [];
        for (let i = questionsCount; i < value; i += 1) {
          questionsToAdd.push(getQuestionToAppend(i));
        }
        onAdd(questionsToAdd);
      } else {
        const toRemove = [];
        for (let i = questionsCount; i > value; i -= 1) {
          toRemove.push(i - 1);
        }
        onRemove(toRemove);
      }
    },
    [onRemove, onAdd, questionsCount, getQuestionToAppend, onChangeQuestionsCountTex]
  );

  return {
    onChangeQuestionsCount: handleChangeQuestionsCount,
  };
}
